module.exports = "<h3 class=\"text-center padding-top text-uppercase\">Categories</h3>\n\n<div class=\"row padding-top padding-bottom-3x\">\n  <div class=\"col-sm-3 col-xs-6\" *ngFor=\"let category of categories\">\n    <a class=\"category-link\"\n       [routerLink]=\"['/shop']\" [queryParams]=\"{ category: category.id }\">\n      <img *ngIf=\"category.img\" src=\"{{ category.img }}\"\n           alt=\"{{ category.name }}\">\n      {{ category.name }}\n    </a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Templates/category.list.html
// module id = ./src/app/Templates/category.list.html
// module chunks = main